import gql from "graphql-tag";
import {IsnResultWithHeaderFragment} from "../../../Queries/Isn";
import {VeriflytResultFragment} from "../../../Queries/Veriflyt";
import {PaxNodeComplianceAuthorizationFieldsFragment, PaxNodeComplianceFieldsFragment} from "../../../Queries/Compliance";

export default gql`
query GetPax(
    $filter: PassengersFilterInput
    $bookmark: String
    $limit: Int
    $skip: Int
){
    passengers(
        filter: $filter
        bookmark: $bookmark
        limit: $limit
        skip: $skip
    ) {
        docs {
            _id,
            ... on PaxNode {
                lastName,
                firstName,
                personID {
                    _id
                    extraBroadState
                }
                customerID {
                    _id
                    name
                }
                employerID {
                    _id
                    name
                },
                tpID {
                    _id
                    name
                }
                paxWeight,
                bagWeight,
                bagCount,
                checkedInTime,
                scheduledFlightDate,
                destinationID {
                    _id, name
                }
                departureID {
                    _id, name
                },
                transitType
                ...PaxNodeComplianceFieldsFragment,
                authorization {
                    onWhiteList
                    noFlyListed
                    ...PaxNodeComplianceAuthorizationFieldsFragment,
                    brdRestriction_SafetyCard {
                        status
                    }
                    brdRestriction_HuetCard {
                        status
                    }
                    brdRestriction_SteelToes {
                        status
                    }
                    brdRestriction_Twic {
                        status
                    }
                    brdRestriction_NonPreferred {
                        status
                    }
                    brdRestriction_Hazmat {
                        status
                    }
                    brdRestriction_NoFlyListed {
                        status
                    }
                    brdRestriction_EbsCard {
                        status
                    }
                    brdRestriction_Illness {
                        status
                    }
                    brdRestriction_Quarantined {
                        status
                    }
                }
                currentCarrierID {
                    _id
                    desig
                }
            }
        }
    }
}
${PaxNodeComplianceFieldsFragment}
${PaxNodeComplianceAuthorizationFieldsFragment}
`